var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-apps-not-found-kitty"},[_c('icon-search-not-found',{staticClass:"page-apps-not-found-kitty__icon"}),_vm._v(" "),_c('span',{staticClass:"page-apps-not-found-kitty__text"},[_vm._v("\n        "+_vm._s(_vm.$t('apps.app.nothing_found'))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }